import { useCallback, useMemo } from "react";

import useProductFilters from "@/tpo/shop/hooks/useProductFilters";

const EVENT_TYPE_OPTIONS = ["IN_PERSON", "ONLINE"];

const EVENT_TYPE_LABELS = {
  IN_PERSON: "In Person",
  ONLINE: "Online"
};

export default function useEventFilters() {
  const getFilterLabel = useCallback((group, value) => {
    if (group === "eventTypes") {
      return EVENT_TYPE_LABELS[value] ?? value;
    }
    return value;
  }, []);

  const { toggleFilter, resetFilters, allFilters, validatedFilters } = useProductFilters({
    defaultFilters: {
      eventTypes: []
    },
    allFilters: {
      eventTypes: EVENT_TYPE_OPTIONS
    },
    getFilterLabel
  });

  const types = useMemo(() => validatedFilters.eventTypes ?? [], [validatedFilters.eventTypes]);

  return {
    toggleFilter,
    resetFilters,
    allFilters,
    validatedFilters,
    types,
    getFilterLabel
  };
}
